
/*
    Wrapper for using the react-datepicker
*/

import React, { Suspense } from "react";

import "react-datepicker/dist/react-datepicker.css";

const DatePicker = React.lazy(() => import('react-datepicker'));

/*
PROPS
    - name
    - value
    - onChange
*/

export default class DateInput extends React.Component {

    updateValue = (date) => {
        // a bit of trickery to make it behave like a normal control when viewed from the outside
        this.props.onChange({target: {name: this.props.name, value: date}});
    }

    render(){

        let date = this.props.value;

        if(!(date instanceof Date)){
            date = new Date(date);
        }

        return (
            <Suspense fallback={<div>Loading...</div>}>
                <DatePicker 
                    selected={date} 
                    onChange={date => this.updateValue(date)} 
                    dateFormat={this.props.dateFormat}
                />
            </Suspense>
        );
    }
}